module.exports = __webpack_public_path__ + "img/shopify.f1f7d9f2.png";